import { useFlipSettings } from "./useFlipSettings";
import { HorizontalIcon } from "components/common/Icons/HorizontalIcon";
import { VerticalIcon } from "components/common/Icons/VerticalIcon";
import { Loader } from "components/common/Icons/Loader/Loader";
import { translateFunc } from "client/utils/translateFunc";
import { UploadImage } from "components/modules/Editors/Flip/EditSettings/UploadImage/UploadImage";

export const FlipSettings = () => {
    const { handleHorizontalToggle, handleVerticalToggle, flipState } = useFlipSettings();

    return (
        <div>
            <div className="hidden lg:block">
                <UploadImage />
            </div>
            <div className="flex items-center gap-4 my-8 select-none">
                <div
                    className="flex-grow w-full text-center"
                    onClick={handleHorizontalToggle}
                    data-testid={`horizontal-flip-button`}
                >
                    <div
                        className={`cursor-pointer dark:bg-darkSurface-200 w-full flex items-center justify-center rounded-2xl border-slate-200 dark:border-darkSurface-400 border py-8 my-2`}
                    >
                        {flipState !== "horizontal" ? (
                            <HorizontalIcon />
                        ) : (
                            <Loader className="stroke-[var(--dark-gray)]" width={34} height={34} />
                        )}
                    </div>
                    <div className="capitalize">{translateFunc("horizontally")}</div>
                </div>
                <div
                    className="flex-grow w-full text-center"
                    onClick={handleVerticalToggle}
                    data-testid={`vertical-flip-button`}
                >
                    <div
                        className={`cursor-pointer dark:bg-darkSurface-200 w-full flex items-center justify-center rounded-2xl border-slate-200 dark:border-darkSurface-400 border py-8 my-2`}
                    >
                        {flipState !== "vertical" ? (
                            <VerticalIcon />
                        ) : (
                            <Loader className="stroke-[var(--dark-gray)]" width={34} height={34} />
                        )}
                    </div>
                    <div className="capitalize">{translateFunc("vertically")}</div>
                </div>
            </div>
        </div>
    );
};
